import ListPageLayout from "../../componets/layout/ListPageLayout";
import userApi from "../../services/userApi";

export default function Users() {
    return(

        <ListPageLayout
            title={'Lista usuários'}
            urlCreate={'/usuarios/formulario'}
            collunSearch={'nome'}
            table={
                {
                    loader: userApi.all,
                    columns: [
                        { label: "Nome", index: "nome", type: 'string'},
                        { label: "E-mail", index: "email", type: 'string'},
                        { label: "Status", index: "status", type: 'status'},
                    ]
                }
            }
        />
    )
}